import { Box, Grid2 as Grid } from "@mui/material";
import { PageContainer } from "./Pages";
import SectionTitle from "./SectionTitle";

export default function IconDesc({ title, items, link }) {
  return (
    <PageContainer>
      <SectionTitle title={title} link={link}/>
      <Grid 
        container
        justifyContent="center"
      >
        {items?.map((icon, index) => (
          <Grid
            key={index}
            sx={{
              padding: 2,
              width:{
                xs: "100%",
                md: "50%",
                lg: "33%",
                xl: "25%"
              },
              
              
            }}
          >
          <Grid
            key={index}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 3,
              height: '200px',
              // cursor: "pointer",
              textAlign: "center",
              boxShadow: 3, 
              padding: 2,
              borderRadius: 10,
              transition: "background-color 0.3s ease",
              // "&:hover": {
              //   boxShadow: 5,
              //   background: "linear-gradient(0deg,rgb(216, 61, 107),rgb(223, 104, 143))",
              // },
              background: "linear-gradient(0deg,rgb(153, 152, 152),rgb(209, 209, 209))",
              color: "white",
            }}
          >
            <Box
              component="img"
              src={icon?.img}
              alt="Icon"
              sx={{
                width: "10vh",
                height: "10vh",
                objectFit: "cover",
                borderRadius: "10%",
              }}
            />
            <Box>{icon.description}</Box>
          </Grid>
          </Grid>
        ))}
      </Grid>
    </PageContainer>
  );
}
